/**
 * OverallController
 * 
 * @Author: Focci
 * @Date: 2024-11-07 09:12:53
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-07 09:12:53
 */

import useStorage from '@hook/useStorage'
import { useLocale } from 'next-intl'
import { fetchGet } from '@lib/fetch/client'
import { useMapState } from '@comp/mapbox'
import { useEffect } from 'react'
import GeolocateItem from './GeolocateItem'
import PropertyItem from './PropertyItem'
import SchoolItem from './SchoolItem'
import RemoteItems from './RemoteItems'
import TrafficItem from './TrafficItem'
import FacilityItem from './FacilityItem'

export default function OverallController({
  options, 
  schoolOpts, 
  propertyOpts,
  traffic,
  facility,
  justDisplayMapboxLayer, // 只渲染地图图层，不渲染其他组件
  ...moreOpt
}) {
  const locale = useLocale()
  const mps = useMapState()

  /**
   * 获取地图 Layers，并存在localSession中
   */
  const storageName = `HG_${process.env.NEXT_PUBLIC_COUNTRY}_${locale}_MAPBOX_REMOTE_LAYERS`
  const mrl = useStorage(storageName, true)
  
  useEffect(() => {
    const c = mps.layers.cfg
    const d = mrl.getItem()

    if(!c) {
      if(d) {
        mps.setLayers((prev) => ({ ...prev, cfg: d }))
      } else {
        fetchGet('map-layers').then((cfg) => {
          mps.setLayers((prev) => ({ ...prev, cfg }))
          mrl.setItem(cfg)
        })
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mps.layers.cfg])

  return !justDisplayMapboxLayer && (
    <div className="pt-1 pb-2">
      <GeolocateItem />
      <PropertyItem options={propertyOpts} />
      <SchoolItem options={schoolOpts} moreOpt={moreOpt} />
      <RemoteItems options={options} moreOpt={moreOpt} />
      {traffic && <TrafficItem />}
      {facility && <FacilityItem />}
    </div>
  )
}
